import React, { ReactElement, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import Viewer from './Viewer/Viewer'
import getContract from '../../content/getContract'
import axios from 'axios'

const ContractView = (): ReactElement => {
  const [contractFile, setContractFile] = useState<string>('')

  let version: string
  let usageType: string
  let type: string
  let fileAlias: string
  const API_URL = `${process.env.GATSBY_API_URL?.replace('/graphql', '')}`

  if (typeof window !== `undefined`) {
    const myKeys = window.location.search
    const urlParams = new URLSearchParams(myKeys)
    version = urlParams.get('v')!
    fileAlias = urlParams.get('fa')!
    usageType = urlParams.get('ut')!
    if (usageType.includes('House')) {
      usageType = 'House & Lot'
    }
    type = urlParams.get('dt')!
  }
  const getFile = async (fileLink: string) => {
    const file = await axios.get(`${API_URL}/${fileLink}`)
    return file
  }

  useEffect(() => {
    const fetchData = async () => {
      const result = await getContract({
        version,
        fileAlias,
        usageType,
        type
      })
      if (result) {
        getFile(result).then((res: any) => {
          setContractFile(res.config.url)
        })
      }
    }
    fetchData()
  }, [])

  return <Viewer pdfFile={contractFile} />
}

export default ContractView
